var site = site || {};
var generic = generic || {};
var page_data = page_data || {};
// Defining SmartGift variables.
var SmartGiftWidget = SmartGiftWidget || {};
var SGBasket = SGBasket || {};

(function ($) {
  Drupal.behaviors.productSmartGiftV1 = {
    attach: function (context) {
      var $smartGift = $('.js-product-smart-gift-v1', context);
      var $smartGiftCta = $('.js-product-smart-gift-cta', $smartGift);
      var $smartGiftToolTip = $('.js-product-smart-gift-tooltip', $smartGift);
      var $productContainer = $('.js-product-full-description', context);
      var self = this;

      if (self.attached || typeof Drupal.settings.smart_gift === 'undefined') {
        return;
      }
      self.attached = true;

      self.loadSmartGiftApi(context);

      $smartGiftToolTip.once().on('click', function (e) {
        e.preventDefault();
        self.showSmartGiftOverlay();
      });

      $smartGiftCta.once().on('click', function (e) {
        e.preventDefault();
        self.addItemToSmartGiftBasket($productContainer);
      });

      self.initSmartGiftAnalytics();
    },

    loadSmartGiftApi: function (context) {
      var smartGiftApiLink = Drupal.settings.smart_gift.api_link;
      var smartGiftMerchantId = Drupal.settings.smart_gift.merchant_id;

      if ($('script[src="' + smartGiftApiLink + '"]', context).length) {
        return;
      }

      // Vendor's script added per API document.
      (function (d, g, e, c, t, s) {
        t = d.createElement(g);
        t.async = 1;
        t.src = e;
        t.onload = function () {
          SmartGiftWidget.mount(c);
        };
        s = d.getElementsByTagName(g)[0];
        s.parentNode.insertBefore(t, s);
      })(document, 'script', smartGiftApiLink, smartGiftMerchantId);
    },

    showSmartGiftOverlay: function () {
      var isMobile = Unison.fetch.now().name === 'small';
      var maxWidth = '620px';
      var maxHeight = isMobile ? 'auto' : '480px';
      var smartGiftContent = $('script.inline-template[path="product_smart_gift_overlay"]').html();

      generic.overlay.launch({
        html: smartGiftContent,
        className: 'product-smart-gift-overlay__colorbox',
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        includeCloseLink: true
      });
    },

    addItemToSmartGiftBasket: function ($productContainer) {
      var productData = page_data['catalog-spp']['products'][0];
      var skuId = parseInt($productContainer.find('.js-add-to-cart').attr('data-sku-base-id'));
      var skuData = _.find(productData.skus, function (sku) {
        return sku.SKU_BASE_ID === skuId;
      });
      var pageUrl = window.location.href;
      var skuTaxedPrice = Number(skuData.formattedTaxedPrice.replace(/[^0-9.]+/g, ''));
      var parsedProductName;
      var smartGiftData;

      if (productData === null || skuData === null) {
        return;
      }
      parsedProductName = $($.parseHTML(productData.PROD_RGN_NAME)).text();
      smartGiftData = {
        skuCode: skuData.SKU_BASE_ID,
        skuUrl: pageUrl,
        price: skuTaxedPrice,
        name: parsedProductName,
        image: skuData.XL_IMAGE[0]
      };
      SGBasket.addItem(smartGiftData);
    },

    initSmartGiftAnalytics: function () {
      var self = this;
      var smartGiftCta = '.js-product-smart-gift-cta';
      var smartGiftTooltip = '.js-product-smart-gift-tooltip';
      var seeGiftCta = '.SGBasket-widget .widget-footer-gotItButton';
      var prepareGiftCta = '.SGBasket-widget .widget-summary-button';
      var cancelGiftCta = '.SGBasket-widget .widget-footer-cancelGift';
      var smartGiftToggleButton = '.SGBasket-widget .SGBasketButton';
      var smartGiftCloseButton = '.product-smart-gift-overlay__colorbox #cboxClose';
      var productData = page_data['catalog-spp']['products'][0];
      var productId = productData.PRODUCT_ID;
      var smartGiftEventContainers = {
        'launch': smartGiftCta,
        'help - open': smartGiftTooltip,
        'see gift': seeGiftCta,
        'prepare my gift': prepareGiftCta,
        'cancel this gift': cancelGiftCta,
        'minimize / maximize': smartGiftToggleButton,
        'help - close': smartGiftCloseButton
      };

      self.addAnalyticsEvent(smartGiftEventContainers, productId);
    },

    addAnalyticsEvent: function (smartGiftEventContainers, productId) {
      var self = this;

      $.each(smartGiftEventContainers, function (eventAction, selector) {
        $(document).on('click', selector, { eventAction: eventAction }, function (e) {
          self.trackEventLink(e.data.eventAction, productId);
        });
      });
    },

    trackEventLink: function (eventAction, productId) {
      var smartGift = 'smartgift';

      site.track.evtLink({
        event_name: smartGift,
        event_category: smartGift,
        event_action: eventAction,
        event_label: productId
      });
    },

    attached: false
  };

  $(document).on('sku:select', '.js-pr-product', function (e, skuData) {
    var soldOutInventoryStatus;
    var $smartGiftContainer;

    if (typeof Drupal.settings.smart_gift === 'undefined') {
      return;
    }
    soldOutInventoryStatus = 7;
    $smartGiftContainer = $(this).find('.js-product-smart-gift-v1');
    $smartGiftContainer.removeClass('hidden');
    if (skuData.INVENTORY_STATUS === soldOutInventoryStatus) {
      $smartGiftContainer.addClass('hidden');
    }
  });
})(jQuery);
